import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/src/css/sprite.scss'
import jcf from "jcf";
import $ from 'jquery';

export const renderInputPhone = (
  telInput
) => {
  const inputPhone = document.querySelector('.form-item-phone input')

  if ($(telInput).length > 0) {
    if(!$(telInput).hasClass('js-webform-telephone-international')) {
      intlTelInput(telInput, {
        initialCountry: "auto",
        autoFormat: false,
        autoHideDialCode: false,
        autoPlaceholder: false,
        defaultCountry: "auto",
        nationalMode: false,
        preventInvalidNumbers: true,
        geoIpLookup: function(success, failure) {
          $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
            const countryCode = (resp && resp.country) ? resp.country : "fr";
            success(countryCode);
          });
        },
      });
    }

    setTimeout(() => {
      $('.iti__flag-container').each(function () {
        const container = $(this)
        const flagHolder = container.find('.iti__selected-flag')
        const flag = flagHolder.find('.iti__flag')
        const input = container.next('input')
        const code = flagHolder.find('.iti__country-code')
        const list = container.find('.iti__country-list')
        const listHolder = container.find('.drop')

        if (!code.length) {
          flagHolder.append('<div class="iti__country-code"></div>')
        }

        if (!listHolder.length) {
          list.wrap( "<div class='drop'><div class='customscroll'></div></div>" )
        }

        function countryChanger() {
          const countryCode = container.find('.iti__country-code')
          let currentCode = flag.attr('class').split(/\s+/)

          countryCode.empty()

          currentCode = $.grep(currentCode, function(value) {
            return value != 'iti__flag';
          });

          $.each(currentCode, function(index, value){
            var result = value.slice(-2)
            countryCode.text(result)
          });
        }

        countryChanger()

        input.on('countrychange', countryChanger);
      })
    }, 1000)
  }

  $(document).on('click', '.iti__flag-container',  function() {
    if($(this).find('.iti__country-list').hasClass('iti__country-list--dropup')) {
      $(".form-item-phone").removeClass("active dropup");
      $(this).parents(".form-item-phone").toggleClass("dropup active");
    } else {
      $(".form-item-phone").removeClass("active dropup");
      $(this).parents(".form-item-phone").toggleClass("active");
    }

    if($(this).find('.iti__country-list').hasClass('iti__hide')) {
      $(".form-item-phone").find('.drop').css('display', 'none');
      $(this).find('.drop').css('display', 'none');
    } else {
      $(".form-item-phone").find('.drop').css('display', 'none');
      $(this).find('.drop').css('display', 'block');
      const customscroll = $(this).find('.customscroll')
      jcf.replace( customscroll, 'Scrollable', {})
    }
  });

  $(document).on('click', function(e) {
    if (!$(e.target).is('.form-item-phone, .form-item-phone *')) {
      $(".form-item-phone").removeClass("active dropup");
      $(".form-item-phone").find('.drop').css('display', 'none');
    }
  });

  $(document).on('click', '.iti__flag-container',  function() {
    if($(this).find('.iti__country-list').hasClass('iti__country-list--dropup')) {
      $(".form-type-tel").removeClass("active dropup");
      $(this).parents(".form-type-tel").toggleClass("dropup active");
    } else {
      $(".form-type-tel").removeClass("active dropup");
      $(this).parents(".form-type-tel").toggleClass("active");
    }

    if($(this).find('.iti__country-list').hasClass('iti__hide')) {
      $(".form-type-tel").find('.drop').css('display', 'none');
      $(this).find('.drop').css('display', 'none');
    } else {
      $(".form-type-tel").find('.drop').css('display', 'none');
      $(this).find('.drop').css('display', 'block');
      const customscroll = $(this).find('.customscroll')
      jcf.replace( customscroll, 'Scrollable', {})
    }
  });

  $(document).on('click', function(e) {
    if (!$(e.target).is('.form-item-phone, .form-item-phone *')) {
      $(".form-type-tel").removeClass("active dropup");
      $(".form-type-tel").find('.drop').css('display', 'none');
    }
  });
}
